import React, { useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { COMTEXT_MENU_ACTIONS } from "../../constants/AppEnums";
import TreeSidebar from "../../components/tree-side-bar/TreeSidebar";
import * as TemplateActions from "../../redux/template/TemplateActions";
import { renameFolderItem, createTemplateFolder, deleteTemplateFolder } from "../../redux/template/TemplateThunk";
import { convertFolderToLabel } from "../../components/tree-item/TreeItem";
import { useState } from "react";
import { TREE_ITEM_TYPES } from "../../constants/AppEnums";
import { styled } from "baseui";
import FolderButtonsGroupComponent from "../../components/folder-buttons-group/FolderButtonsGroupComponent";
import { useHistory, useLocation } from "react-router-dom";
import useRouteParams from "../../hooks/useRouteParams";

const MainFlexContainer = styled("div", (props) => ({
  display: "flex",
  flexDirection: "column",
  // justifyContenet: 'space-between',
}));

const AddGroupArea = styled("div", ({ $theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

function TemplateFolderTreeSidebar(props) {
  const history = useHistory();
  const { pathParams, searchParams, searchPart } = useRouteParams();
  const { templateFolders } = props;
  const [treeData, setTreeData] = useState(templateFolders);
  const [childKey, setitemschildKey] = useState(7);
  const location = useLocation();
  const removeQueryParam = () => {
    const params = new URLSearchParams(history.location.search);
    params.delete('objId'); // Replace 'paramToRemove' with the name of the parameter you want to remove
    params.delete('fileId'); // Replace 'paramToRemove' with the name of the parameter you want to remove
    history.push({ search: params.toString() });
  };
  const forceUpdate = () => {
    setitemschildKey(childKey * 89);
  };

  useEffect(() => {
    props.onSetSelectedFolder({ id: searchParams["fileId"] });
  }, []);

  useEffect(() => {
    setTreeData(props.templateFolders);
    forceUpdate();
  }, [props.templateFolders]);

  useEffect(() => {
    let queryParam = "";
  
    if (props.selectedFolder) {
      switch (props.selectedFolder.type) {
        case TREE_ITEM_TYPES.FILE:
          queryParam = `?fileId=${props.selectedFolder.id}`;
          break;
        case TREE_ITEM_TYPES.OBJECT:
          queryParam = `?objId=${props.selectedFolder.id}`;
          break;
        default:
          queryParam = "";
      }
    }
  
    history.push({
      search: queryParam,
    });
  }, [props.selectedFolder, history]);
  const onContextMenuItemClick = ({ action, node }) => {
    if (action.action === COMTEXT_MENU_ACTIONS.DELETE) {
      props.ondeleteTemplateFolder(node.id);
      removeQueryParam();
    }
    if (action.action === COMTEXT_MENU_ACTIONS.NEWFOLDER) {
      props.onAddNewTemplateFolder(node, {
        isEditing: true,
        name: "New folder",
        templateId: props.templateId,
        path: Boolean(node.path) ? `${node.path}.${node.id}` : `${node.id}`,
        type: TREE_ITEM_TYPES.FOLDER,
      });
    }
    if (action.action === COMTEXT_MENU_ACTIONS.NEWFILE) {
 
      props.onAddNewTemplateFolder(node, {
        isEditing: true,
        name: "New file",
        templateId: props.templateId,
        path: Boolean(node.path) ? `${node.path}.${node.id}` : `${node.id}`,
        type: TREE_ITEM_TYPES.FILE       
      });
    }
    if (action.action === COMTEXT_MENU_ACTIONS.NEWOBJECT) {
 
      props.onAddNewTemplateFolder(node, {
        isEditing: true,
        name: "New object",
        templateId: props.templateId,
        path: Boolean(node.path) ? `${node.path}.${node.id}` : `${node.id}`,
        type: TREE_ITEM_TYPES.OBJECT
      });
    }    
    if (action.action === COMTEXT_MENU_ACTIONS.RENAME) {
      props.onUpdateFolderNode(node, {
        isEditing: true,
      });
    }
    setTreeData(templateFolders);
    forceUpdate();
  };

  function onToggleFolder(node) {
    props.onToggleTemplateFolder(node);
  }

  function onLabelChange(node, label) {
    if (label === "" || label === undefined) {
      props.ondeleteTemplateFolder(node.id);
    } else {
      props.onUpdateFoldersItem(node.id, label);
    }
    setTreeData(templateFolders);
    forceUpdate();
  }
  const handleLeafNodeClick = (node) => {
    props.onSetSelectedFolder(node);
    forceUpdate();
  };
  const handleParentNodeClick = (node) => {
    props.onSetSelectedFolder(node);
    forceUpdate();
  };
  return (
    <MainFlexContainer>
      <FolderButtonsGroupComponent />
      <br />
      {treeData && treeData.length !== 0 && (
        <TreeSidebar
          key={childKey}
          treeData={convertFolderToLabel(
            treeData,
            onContextMenuItemClick,
            onLabelChange,
            handleParentNodeClick,
            true
          )}
          onToggle={(node) => onToggleFolder(node)}
          onLeafNodeClicked={(node) => handleLeafNodeClick(node)}
          onParentNodeClicked={(node) => handleParentNodeClick(node)}
        ></TreeSidebar>
      )}
    </MainFlexContainer>
  );
}

const mapStateToProps = (state) => {
  return {
    templateFolders: state.template.activeTemplate?.folders,
    selectedFolder: state.template.activeTemplate?.selectedFolder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ondeleteTemplateFolder: (folderId) => {
      dispatch(deleteTemplateFolder(folderId));
    },
    onAddNewTemplateFolder: (node, folder) => {
      dispatch(createTemplateFolder(node, folder));
    },
    onToggleTemplateFolder: (node) => {
      dispatch(TemplateActions.toggleTemplateFolder(node));
    },
    onUpdateFoldersItem: (folderId, folderName) => {
      dispatch(renameFolderItem( folderId, folderName));
    },
    onUpdateFolderNode: (node, folder) => {
      dispatch(TemplateActions.updateFoldersNode({ node, folder }));
    },
    onSetSelectedFolder: (node) => {
      dispatch(TemplateActions.setSelectedFolder(node));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateFolderTreeSidebar);
